import { Tooltip } from '../tooltip'

interface AssignedClinicianSectionProps {
  clinicianName: string
  clinicianEmail?: string
  onClinicianNameClick?: () => void
  emailCopied?: boolean
}

export function AssignedClinicianSection({
  clinicianName,
  clinicianEmail,
  onClinicianNameClick,
  emailCopied = false,
}: AssignedClinicianSectionProps) {
  const tooltipText = emailCopied ? 'Email copied!' : 'Click to copy email'

  return (
    <div className="pl-6 mt-4">
      <p className="text-sm font-medium text-charcoal-50">Assigned Clinician</p>
      <div className="flex items-center gap-2 mt-1">
        {clinicianEmail ? (
          <Tooltip key={tooltipText} text={tooltipText} placement="top" delay={0}>
            <button
              type="button"
              onClick={onClinicianNameClick}
              className="text-indigo underline font-medium hover:text-indigo-dark cursor-pointer inline-flex items-center gap-2"
            >
              <span>{clinicianName}</span>
              <i className="fa-solid fa-envelope text-sm" aria-hidden="true" />
            </button>
          </Tooltip>
        ) : (
          <span className="text-charcoal font-medium">{clinicianName}</span>
        )}
      </div>
    </div>
  )
}
